(function () {
    'use strict';

    angular.module('swif.framework')
    .service('swifOnIdleTimeService', swifOnIdleTimeService);

    /**
    * @ngdoc service
    * @name swif.framework.swifOnIdleTimeService
    **/
    function swifOnIdleTimeService($interval) {
        'ngInject';
        var service = {
            idleTime: 0,
            maxIdleTime: 29,
            onIdleTimeSpent: false,
            idleInterval: false,
            timerIncrement: timerIncrement,
            resetIdleTime: resetIdleTime
        };
        //Increment the idle time counter every minute.
        service.idleInterval = $interval(service.timerIncrement, 60000);

        function timerIncrement() {
            service.idleTime = service.idleTime + 1;
            if (service.idleTime > service.maxIdleTime - 1 && service.onIdleTimeSpent) {
                service.onIdleTimeSpent();
                service.idleTime = 0;
            }
        }
        function resetIdleTime () {
            service.idleTime = 0;
        }
        return service;
    }


})();